import "./TestConfigurationViewComponent.scss";
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import React from "react";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from '@mui/icons-material/Edit';

interface TestPanelConfigurationViewComponentProps {
    testDetails: any;
    onEditModeOpen: Function;
    canEdit: boolean;
}

const TestConfigurationViewComponent = (props: TestPanelConfigurationViewComponentProps) => {
    const {
        testDetails,
        onEditModeOpen,
        canEdit
    } = props;


    // const downloadBulkImportTemplate = useCallback((attachment: any, type: string) => {
    //     CommonService.downloadFile(attachment.url, attachment.title || type, 'xlsx')
    // }, []);

    return (
        <div className={'test-panel-configuration-view-component details-tab-data-content'}>
            {
                testDetails && <>
                    <div className="details-tab-data-header">
                        <div className="view-and-edit-title">Intake Form</div>
                        {canEdit &&
                            <div className="">
                                <ButtonComponent
                                    className={"white-space-nowrap"}
                                    type="button"
                                    color={"primary"}
                                    variant={"outlined"}
                                    startIcon={<EditIcon/>}
                                    fullWidth={true}
                                    handleClick={onEditModeOpen}
                                >
                                    Edit Details
                                </ButtonComponent>
                            </div>
                        }
                    </div>
                    <div className="details-tab-data-body">
                        <Grid container spacing={2} className="pdd-top-0">
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Is Intake Form required?"}> {testDetails?.isIntakeFormRequired ? "Yes" : 'No'} </DetailsDataKeyValueComponent>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                            </Grid>
                        </Grid>
                        <div className="horizontal-line"/>
                        <div className="details-tab-data-header">
                            <div className="view-and-edit-title">State Reporting</div>
                        </div>
                        <Grid container spacing={2} className="pdd-top-0">
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Is State Reporting required?"}> {testDetails?.isStateReportingRequired ? 'Yes' : 'No'} </DetailsDataKeyValueComponent>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                {testDetails?.isStateReportingRequired && <>
                                    <DetailsDataKeyValueComponent
                                        title={"Reporting Schedule"}> {testDetails?.reportingSchedule || '-'} </DetailsDataKeyValueComponent>
                                </>
                                }
                            </Grid>
                        </Grid>
                        {testDetails?.isStateReportingRequired &&
                            <Grid container spacing={2} className="pdd-top-0">
                                <Grid item xs={12} sm={12} md={6} xl={6}>
                                    <DetailsDataKeyValueComponent
                                        title={"Loinic Test Name"}> {testDetails?.loincName || '-'} </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"State Reporting Url"}> {testDetails?.stateReportConfig?.url || testDetails?.stateReportingUrl || '-'} </DetailsDataKeyValueComponent>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} xl={6}>
                                    <DetailsDataKeyValueComponent
                                        title={"Loinic Specimen Code"}> {testDetails?.loincCode || '-'} </DetailsDataKeyValueComponent>
                                </Grid>
                            </Grid>
                        }
                        <div className="horizontal-line"/>
                        <div className="view-and-edit-title">Bulk Import</div>
                        <Grid container spacing={2} className="pdd-top-0">
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Is Bulk Import required?"}> {testDetails?.isBulkImportRequired ? "Yes" : 'No'} </DetailsDataKeyValueComponent>
                                {/*{*/}
                                {/*    testDetails?.isBulkImportRequired  &&  (testDetails.bulkImportTemplate ?*/}
                                {/*        <ChipComponent*/}
                                {/*            className="mrg-top-10"*/}
                                {/*            label={'Result Template.xls'}*/}
                                {/*            onClick={() => downloadBulkImportTemplate(testDetails.bulkImportTemplate, 'Bulk Import Template.xls')}*/}
                                {/*            icon={<AttachFile/>}*/}
                                {/*        />*/}
                                {/*        : '-')*/}
                                {/*}*/}
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                            </Grid>
                        </Grid>
                        {/*<div className="horizontal-line"/>*/}
                        {/*<div className="view-and-edit-title">Panel Result Template</div>*/}
                        {/*{*/}
                        {/*    testDetails.panelResultTemplate ?*/}
                        {/*        <ChipComponent*/}
                        {/*            className="mrg-top-10"*/}
                        {/*            label={'Result Template.xls'}*/}
                        {/*            onClick={() => downloadBulkImportTemplate(testDetails.panelResultTemplate, 'Result Template.xls')}*/}
                        {/*            icon={<AttachFile/>}*/}
                        {/*        />*/}
                        {/*        : '-'*/}
                        {/*}*/}

                    </div>
                </>
            }
        </div>
    );

};

export default TestConfigurationViewComponent;